import React from 'react';
import MasterPage from 'components/MasterPage';
import S3Explorer from './S3Explorer';

function NFexplorer() {
  return (
    <>
      <S3Explorer></S3Explorer>
    </>
  );
}

export default MasterPage(NFexplorer);
